var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_931_4905)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.58335,
    cy: 9.58366,
    r: 7.91667,
    stroke: "#666D80",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 16.667L18.3334 18.3337",
    stroke: "#666D80",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_931_4905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.19f4c57cdf2445630651dcb2f28613ce.svg";
export { ForwardRef as ReactComponent };